<template>
  <v-card
    v-if="moment"
    class="container pa-0"
    :class="rarityClass"
    @click="
      $router.push(
        `/collectibles/${collectible.collectibleId}/${token.tokenId}`
      )
    "
  >
    <div>
      <video
        :poster="token.isPremium ? moment.foilImageUrl : moment.imageUrl"
        class="videoFrame"
        muted
        autoplay
        loop
      >
        <source :src="moment.videoUrl" type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <!-- <div class="gradient" /> -->
      <div v-if="token.isPremium" class="premium">
        Premium
      </div>
      <div v-if="showListing && token.listing" class="claim">
        <v-btn class="ma-0 blackButton" style="font-size: 14px !important;" fab>
          Listed
        </v-btn>
      </div>
      <div
        v-else-if="
          showClaim &&
            (moment.rarity === 'instant' ||
              moment.rarity === 'special' ||
              moment.rarity === 'gmp' ||
              token.isClaimed)
        "
        class="claim"
      >
        <v-btn
          v-if="
            (token.collectible.claimExpiryDate &&
              $moment(token.collectible.claimExpiryDate) > Date.now()) ||
              token.isClaimed
          "
          class="ma-0"
          :class="token.isClaimed ? 'blackButton' : 'yellowButton'"
          style="font-size: 14px !important;"
          fab
          @click.stop="token.isClaimed ? '' : $emit(`claimToken`, token)"
        >
          {{ token.isClaimed ? 'Claimed' : 'Claim' }}
        </v-btn>
        <v-btn
          v-else
          class="ma-0 blackButton"
          style="font-size: 14px !important;"
          fab
        >
          Expired
        </v-btn>
      </div>
    </div>

    <div class="px-3 pb-3">
      <!-- <div class="artistText">
        {{ collectible.artist }}
      </div>
      <div class="collectibleText">
        {{ collectible.name }} #{{ token.tokenId }}
      </div> -->
      <v-card-actions class="ma-0 pa-0">
        <div class="rarityText">{{ moment.rarity }}</div>
        <v-spacer />
        <div v-if="tokenCount > 1 && !token.listing" class="rarityText">
          Copies: {{ tokenCount }}
        </div>
      </v-card-actions>
      <div class="nameText">
        {{ moment.name }}
      </div>
      <div v-if="showPrice && listing" class="priceText">
        {{ listing.price }} GM Points
      </div>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'ListingView',

    components: {},

    props: [
      'collectible',
      'moment',
      'listing',
      'token',
      'showClaim',
      'showListing',
      'showPrice',
      'tokenCount',
    ],

    data() {
      return {};
    },

    computed: {
      rarityClass() {
        return `rarity-${this.moment.rarity}`;
      },
    },
  };
</script>

<style scoped>
  .container {
    position: relative;
  }

  .rarity-common {
    background: #f0f0f0;
    color: #000;
  }

  .rarity-rare {
    background: linear-gradient(94deg, #ffb8e7 3.41%, #baeeff 84.75%);
    color: #000;
  }

  .rarity-epic {
    background: linear-gradient(94deg, #ffb8e7 3.41%, #baeeff 84.75%);
    color: #000;
  }

  .rarity-legendary {
    background: linear-gradient(94deg, #ffb8e7 3.41%, #baeeff 84.75%);
    color: #000;
  }

  .rarity-instant {
    background: linear-gradient(94deg, #fed85d 3.41%, #e6b928 84.75%);
    color: #000;
  }

  .rarity-special {
    background: linear-gradient(94deg, #fed85d 3.41%, #e6b928 84.75%);
    color: #000;
  }

  .rarity-gmp {
    background: linear-gradient(94deg, #fed85d 3.41%, #e6b928 84.75%);
    color: #000;
  }

  .collectibleText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 16px !important;
    color: #fff;
  }

  .nameText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-size: 18px !important;
    line-height: 24px !important;
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis !important;
  }

  .artistText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 12px !important;
    line-height: 12px !important;
    color: #ec11a0;
    text-transform: capitalize;
  }

  .rarityText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 12px !important;
    line-height: 12px !important;
    text-transform: capitalize;
  }

  .priceText {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    line-height: 14px !important;
  }

  .gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.01),
      rgba(0, 0, 0, 0.02),
      rgba(0, 0, 0, 0.15),
      rgba(0, 0, 0, 0.35),
      rgba(0, 0, 0, 0.5)
    );
  }

  .content {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }

  .claim {
    position: absolute;
    top: 2%;
    right: 2%;
  }

  .premium {
    position: absolute;
    top: 2%;
    left: 2%;
    background: #9b59b6;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 12px !important;
    line-height: 16px !important;
    text-align: center;
    color: #fff;
    height: 24px;
    padding: 4px;
    border-radius: 12px;
  }
</style>
